// extracted by mini-css-extract-plugin
export default {"company":"sectionImage_company__Hv48F","companyText":"sectionImage_companyText__Ohry+"};